import img_upload from "assets/img/upload.svg";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { useState } from "react";
import { ModalUploadNotificationDocument } from "../ModalUploadNotificationDocument";

export const MenuItemButtonUploadNotificationDocument = ({
  assignmentId,
}: {
  assignmentId: number;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ModalUploadNotificationDocument
        open={open}
        handleClose={() => setOpen(false)}
        assignmentId={assignmentId}
      />
      <MenuItemButton
        onClick={() => setOpen(true)}
        iconSrc={img_upload}
        title="Отправить документ-уведомление"
      />
    </>
  );
};
